module.exports = __webpack_public_path__ + "media/images/icons/filled/zhihu-square-a49911e161aa942f3b251e1e654232a9.svg";